import { RLink } from '../remote/link';
import { Link } from '../domain/link';
import { SyncState } from '../../../General/domain/general';

export const mapLink = (link: RLink): Link => {
    return {
        id: link.documentId,
        label: link.label,
        url: link.url,
        syncState: SyncState.Synced
    };
};

export const mapLinks = (links: RLink[] | undefined): Link[] => {
    return links ? links.map(mapLink) : [];
};

/**
 * Reverse map a domain Link to a Remote Link in order to create/update links at the backend
 *
 * If the syncState of the Link is SyncState.New, the ID will not be sent to the backend so that an id will be created
 *
 * @param link The link to map
 */
export const mapLinkToRLink = (link: Link): Partial<RLink> => {
    return {
        documentId: link.syncState === SyncState.New ? undefined : link.id,
        label: link.label,
        url: link.url
    };
};
